const options = {
	root: null,
	rootMargin: '0px',
	threshold: 0.2
};

const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach(entry => {
    	if (entry.isIntersecting) {
      		entry.target.classList.add('in-view');
    	} else {
      		entry.target.classList.remove('in-view');
    	}
  	});
}, options);

// Observe the video wrappers 

const videoWrappers = document.querySelectorAll('.inline-video-wrapper');

videoWrappers.forEach(element => {
	
	observer.observe(element);

	const playButton = element.querySelector('.btn-play');
	const closeBtn = element.querySelector('.btn-close');
	const posters = element.querySelectorAll('.video-poster-wrapper');
	const videos = element.querySelectorAll('video');
	//check what video is visible - desktop or mobile
	const isVisible = (video) => !!(video.offsetWidth || video.offsetHeight || video.getClientRects().length);

	// Close and mute the video

	closeBtn.addEventListener('click', () => {

		playButton.classList.remove('is-hidden');
		closeBtn.classList.add('is-hidden');

		posters.forEach((poster) => {
			poster.classList.remove('is-hidden');
		});

		videos.forEach((video) => {
			video.classList.remove('is-playing');
			video.pause();
			video.muted = true;
		});

	});

	// TODO: Keep code dry
	// Play and unmute the video

	playButton.addEventListener('click', () => {

		playButton.classList.add('is-hidden');
		closeBtn.classList.remove('is-hidden');

		posters.forEach((poster) => {
			poster.classList.add('is-hidden');
		});

		videos.forEach((video) => {
			if (isVisible(video)) {
				video.classList.add('is-playing');
				video.muted = false;
				video.play();
			} else {
				video.classList.remove('is-playing');
				video.pause();
				video.muted = true;
			}
		});
	});

	// Close on esc keydown

	document.addEventListener('keydown', (event) => {
    	if (event.key === 'Escape') {
        	playButton.classList.remove('is-hidden');
			closeBtn.classList.add('is-hidden');

			posters.forEach((poster) => {
				poster.classList.remove('is-hidden');
			});

			videos.forEach((video) => {
				video.classList.remove('is-playing');
				video.pause();
				video.muted = true;
			});
    	}
	});
});
